// src/lib/utils/permission/permissionDefaults.js
import { PERM } from "./permissions";

// ✅ role별 "기본 권한 세트" 생성기
export function buildDefaultPermissionByRole(role = "user") {
  const all = {
    [PERM.PROJECT_CREATE_FILE_UPLOAD]: true,
    [PERM.PROJECT_UPDATE_FILE_UPDATE]: true,
    [PERM.PROJECT_DELETE_FILE_DELETE]: true,
    [PERM.PROJECT_READ]: true,
    [PERM.REPORT_CREATE]: true,
    [PERM.OBJECT3D_CREATE]: true,
    [PERM.NOTICE_WRITE_EDIT]: true,
    [PERM.USER_REGISTER]: true,
    [PERM.USER_PERMISSION_EDIT]: true,
    [PERM.ORGANIZATION_CREATE]: true,
  };

  // ✅ master: 전권
  if (role === "master") return all;

  // ✅ admin/manager: 시스템 글로벌 공지 작성/수정만 제외
  if (role === "admin" || role === "manager") {
    return { ...all, [PERM.NOTICE_WRITE_EDIT]: false };
  }

  // ✅ user: 기본 작업만 허용
  return {
    [PERM.PROJECT_CREATE_FILE_UPLOAD]: true,
    [PERM.PROJECT_UPDATE_FILE_UPDATE]: true,
    [PERM.PROJECT_DELETE_FILE_DELETE]: true,
    [PERM.PROJECT_READ]: true,
    [PERM.REPORT_CREATE]: true,

    [PERM.OBJECT3D_CREATE]: false,
    [PERM.NOTICE_WRITE_EDIT]: false,
    [PERM.USER_REGISTER]: false,
    [PERM.USER_PERMISSION_EDIT]: false,
    [PERM.ORGANIZATION_CREATE]: false,
  };
}
